import { saveToStorage } from '../used-vue/api/Storage';

/**
 * Update the global customer location data and also save in storage
 * @param {Float} lat
 * @param {Float} lng
 * @param {String} postcode
 * @param {Boolean} geolocation
 */
export default function(lat = 0, lng = 0, postcode = '', geolocation = false) {
    customerLat = lat;
    customerLng = lng;
    customerPostcode = postcode;
    customerGeolocation = (geolocation == true) ? 1 : 0;

    saveToStorage('lat', customerLat);
    saveToStorage('lng', customerLng);
    saveToStorage('postcode', customerPostcode);
    saveToStorage('geolocation', customerGeolocation);
}


// WEBPACK FOOTER //
// ./resources/assets/js/modules/storeCustomerPositionData.js